import { ScopeVersion } from '@app/core/model/scope-version'
import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { plainToInstance } from 'class-transformer'
import { ScopeSection } from '../../model/scope-section'
import { Dictionary, keyBy } from 'lodash'
import { SectionWithChanges } from '@app/shared/components/scope-elements/models/entities-with-changes/section-with-changes.interface'
import { getSectionChanges } from './entity-changes'
import { filterNetChangesDeliverables } from '../store/selectors/change-request.selectors'

export function mapChangeRequestSections(
  scope: ScopeVersion,
  previewScope: ScopeVersion,
  deliverablesBySection: Dictionary<Deliverable[]>,
  isNetChanges = false
): SectionWithChanges[] {
  const scopeSections = scope?.sections || []
  const previewSections = previewScope?.sections || []

  if (previewSections.length && !scopeSections.length) return []

  const scopeSectionIds = new Set(scopeSections.map((p) => p.id))
  const previewSectionsMap = keyBy(previewSections, 'id')
  const scopeSectionsMap = keyBy(scopeSections, 'id')

  const allSections = [...scopeSections, ...previewSections.filter((p) => !scopeSectionIds.has(p.id))]

  const mappedSections = plainToInstance(
    ScopeSection,
    allSections
      .sort((a, b) => a.order - b.order)
      .map((section: ScopeSection) => {
        const deliverables = (deliverablesBySection[section.id] || []).sort((a, b) => a.order - b.order)
        const previewDeliverables = deliverables.filter((d) => !d.isRemoved)

        return {
          ...section,
          deliverables: isNetChanges ? filterNetChangesDeliverables(deliverables) : deliverables,
          changes: getSectionChanges(
            scopeSectionsMap[section.id],
            previewSectionsMap[section.id],
            !!previewScope,
            previewDeliverables
          ),
        }
      })
  )

  return isNetChanges ? mappedSections.filter((s) => s.deliverables?.length) : mappedSections
}
